import { Button, ButtonProps, StackProps } from '@mui/material'
import useSubmitLock from 'hooks/use-submit-lock'
import { Buttoncontainer, SubmitButton } from './action-buttons.styles'

type ActionButtonsProps = {
  firstBtnProps: { bgcolor?: string } & ButtonProps
  secondBtnProps?: { bgcolor?: string } & ButtonProps
  thirdBtnProps?: { bgcolor?: string } & ButtonProps
  isSubmitForm?: boolean
  containerSx?: StackProps['sx']
}

const disabledSx = {
  '&.Mui-disabled': {
    bgcolor: 'action.disabledBackground',
    color: 'action.disabled',
  },
}

const ActionButtons = ({
  firstBtnProps,
  secondBtnProps,
  thirdBtnProps,
  isSubmitForm = false,
  containerSx,
}: ActionButtonsProps) => {
  const firstLock = useSubmitLock()
  const secondLock = useSubmitLock()
  const thirdLock = useSubmitLock()

  return (
    <Buttoncontainer
      direction="row"
      justifyContent="center"
      spacing={2}
      p={1}
      borderTop={0.6}
      sx={containerSx}
    >
      {thirdBtnProps && (
        <Button
          {...thirdBtnProps}
          disabled={!!thirdBtnProps.disabled || thirdLock.isSubmitting}
          sx={{
            bgcolor: thirdBtnProps.bgcolor ?? 'primary.main',
            color: 'common.white',
            borderRadius: '6px',
            textTransform: 'capitalize',
            fontWeight: 700,
            fontSize: '0.875rem',
            paddingX: '12px',
            paddingY: '6px',
            minWidth: '170px',
            ...disabledSx,
          }}
          onClick={thirdLock.wrapClick(thirdBtnProps.onClick)}
        >
          {thirdBtnProps.title}
        </Button>
      )}
      <Button
        {...firstBtnProps}
        disabled={!!firstBtnProps.disabled || firstLock.isSubmitting}
        sx={{
          bgcolor: firstBtnProps.bgcolor ?? 'primary.main',
          color: 'common.white',
          borderRadius: '6px',
          textTransform: 'capitalize',
          fontWeight: 700,
          fontSize: '0.875rem',
          paddingX: '12px',
          paddingY: '6px',
          minWidth: '170px',
          ...disabledSx,
        }}
        onClick={firstLock.wrapClick(firstBtnProps.onClick)}
      >
        {firstBtnProps.title}
      </Button>
      {secondBtnProps && (
        <>
          {isSubmitForm ? (
            <SubmitButton
              type="submit"
              value={secondBtnProps.title}
              disabled={!!secondBtnProps.disabled || secondLock.isSubmitting}
              onClick={secondLock.wrapClick(secondBtnProps.onClick)}
            />
          ) : (
            <Button
              {...secondBtnProps}
              disabled={!!secondBtnProps.disabled || secondLock.isSubmitting}
              sx={{
                bgcolor: secondBtnProps.bgcolor ?? 'error.main',
                color: 'common.white',
                borderRadius: '6px',
                textTransform: 'capitalize',
                fontWeight: 700,
                fontSize: '0.875rem',
                paddingX: '12px',
                paddingY: '6px',
                minWidth: '170px',
                ...disabledSx,
              }}
              onClick={secondLock.wrapClick(secondBtnProps.onClick)}
            >
              {secondBtnProps.title}
            </Button>
          )}
        </>
      )}
    </Buttoncontainer>
  )
}

export default ActionButtons
